<template>
  <svg
    width="122.35503"
    height="139.99992"
    viewBox="0 0 122.35503 139.99992"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs35" />
    <path
      id="path1"
      d="m 59.88229,137.77806 c -2.73113,0 -5.34418,-1.16834 -7.17163,-3.19941 L 29.91409,109.16099 19.74264,97.81352 l -3.13398,-3.48821 -0.0486,-0.0611 -0.0369,-0.0365 c -2.31182,-2.81667 -4.34253,-5.845 -6.06032,-9.03162 h 99.20125 c -1.14787,2.12867 -2.43393,4.18387 -3.84244,6.13745 l -38.78012,43.24109 c -1.82343,2.03509 -4.43648,3.19905 -7.17126,3.19905 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path2"
      d="m 105.81758,87.40994 c -0.54542,0.86273 -1.11935,1.70938 -1.71376,2.53957 l -8.16048,9.10108 -7.73753,8.62438 -22.8046,25.42607 c -1.42461,1.5913 -3.38659,2.46646 -5.52331,2.46646 -2.13672,0 -4.0987,-0.87516 -5.52294,-2.46646 L 31.55803,107.6874 21.38256,96.33555 18.26101,92.85977 c -1.42862,-1.73789 -2.74319,-3.55731 -3.94004,-5.44581 h 91.49223 m 7.43228,-4.42405 H 6.8970904 c 2.1126,4.59513 4.8067996,8.86858 7.9897696,12.73112 0.0121,0.0124 0.0161,0.0205 0.0245,0.0325 l 3.1826,3.54524 10.17145,11.34747 22.79656,25.41802 c 2.35277,2.62511 5.58436,3.93566 8.81594,3.93566 3.23159,0 6.46354,-1.31055 8.81594,-3.93566 l 22.80497,-25.42607 7.73314,-8.62474 8.3195,-9.27582 c 2.2018,-3.0404 4.10675,-6.30452 5.69001,-9.74374 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path3"
      d="m 118.18717,58.52016 c 0,6.06434 -0.91976,11.90495 -2.6295,17.40376 -0.0896,0.29318 -0.18315,0.58637 -0.27673,0.87114 -0.0976,0.29318 -0.19521,0.58198 -0.29282,0.86675 -0.60245,1.72985 -1.2824,3.41912 -2.03509,5.07147 -0.0369,0.0855 -0.0735,0.16706 -0.11406,0.25224 -1.58326,3.43923 -3.49223,6.69969 -5.69,9.74411 -2.4299,3.38219 -5.2261,6.4957 -8.3195,9.27581 -10.37069,9.34893 -24.09907,15.04296 -39.1625,15.04296 -16.46792,0 -31.3482,-6.80095 -41.97916,-17.75361 -1.11534,-1.13581 -2.16962,-2.32024 -3.18297,-3.54524 -0.0121,-0.0121 -0.0165,-0.0205 -0.0245,-0.0325 -3.18296,-3.86254 -5.8811896,-8.13599 -7.9897596,-12.73149 -0.0406,-0.0852 -0.0771,-0.1667 -0.11369,-0.25224 C 3.0148304,75.35441 1.1466604,67.15299 1.1466604,58.5202 1.1426604,26.19923 27.35002,0 59.66696,0 c 32.31658,0 58.5202,26.19923 58.5202,58.5202 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path4"
      d="m 76.37434,91.29662 c 0.10163,9.28824 15.84098,11.22939 21.16066,9.38987 5.41327,-1.87644 10.28112,-18.70225 14.88028,-33.57046 1.27399,-4.12283 3.26814,-7.95687 5.00201,-11.91336 3.00384,-6.86603 3.29702,-11.28642 0.0285,-15.20161 -0.29282,-3.36209 -1.77445,-4.70518 -4.50558,-5.38476 -1.47724,-4.42442 -7.1391,-6.91135 -13.50466,-5.104 -3.60592,-0.37032 -4.79474,-0.37032 -8.07494,2.49899 -2.55602,-0.61049 -6.01572,1.72985 -6.91939,5.93822 -4.52203,0.51691 -3.44325,6.431 -3.02797,15.8695 -0.14659,3.13398 -5.1815,24.18863 -5.03491,37.48163 z"
      fill="#eff0f4"
      stroke="#e3e4e9"
      stroke-width="5.14"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      id="path5"
      d="m 92.87882,31.88956 2.91829,9.25535 c 3.73204,-1.13947 7.23671,-0.73259 10.48035,1.4447 l 4.8313,-1.72144 c -1.57522,-2.39334 -5.31165,-4.11076 -5.33577,-6.72783 l -3.52879,-4.17182 -3.03638,0.56955 c -2.82471,-0.41491 -4.46499,-0.008 -6.33302,1.35149 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path6"
      d="m 86.95778,34.94969 c -0.59441,0.79364 -1.13983,1.62421 -1.3471,2.66606 l 10.01645,12.66204 9.45896,-7.38293 c -2.51947,-1.966 -5.86108,-2.10455 -9.75617,-1.01371 -0.43538,-4.66825 -1.81539,-7.93273 -4.38347,-8.89307 -1.34309,-0.25663 -2.95888,0.6836 -3.98465,1.95759 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path7"
      d="m 84.43685,37.94549 c 18.6858,16.43502 20.60684,41.40925 13.89947,62.04899"
      stroke="#e3e4e9"
      stroke-width="5.14"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="path8"
      d="M 95.39792,51.68631 C 99.66734,46.4072 108.30817,40.90875 117.44178,40.00106"
      stroke="#e3e4e9"
      stroke-width="5.14"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="path9"
      d="m 91.35661,32.00727 c 2.7717,1.82746 4.04167,5.69805 4.21276,9.01919 4.07018,-1.02979 8.31109,-0.48437 10.22811,1.87242"
      stroke="#e3e4e9"
      stroke-width="5.14"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      id="path10"
      d="m 99.37635,29.50389 c 4.12283,0.67958 5.94224,4.42405 6.11734,7.08609 2.95888,0.0325 5.92616,2.36081 6.11735,4.43648"
      stroke="#e3e4e9"
      stroke-width="5.14"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      id="path11"
      d="m 68.2548,108.33043 c -13.19137,0 -27.15189,-2.32023 -32.69128,-3.54524 -0.28916,-0.0651 -0.57796,-0.13416 -0.86712,-0.20764 C 24.58234,101.94001 17.63882,92.64006 17.81758,81.96413 L 18.00512,70.76728 C 15.47322,69.72103 6.8773504,65.74882 3.5967504,58.7724 -0.41231962,50.23319 0.33658038,40.18018 5.6073904,31.87713 11.28532,22.93507 21.05758,17.59492 31.74557,17.59492 c 0.9607,0 1.94151,0.045 2.91427,0.1305 5.56389,-4.39587 12.89417,-6.81352 20.70079,-6.81352 9.01115,0 17.35917,3.26423 22.90258,8.95024 4.99397,5.12411 7.52952,12.00293 7.33028,19.89874 -0.0164,0.6635 -0.049,1.4246 -0.0855,2.2548 -0.19119,4.54652 -0.50886,12.15354 1.60373,14.64047 0.8057,0.94827 4.10675,2.29135 6.12137,2.29135 0.3418,0 0.54944,-0.045 0.65107,-0.0815 0.0165,-2.16926 0.86309,-3.47176 1.57521,-4.18388 0.89125,-0.89563 2.08006,-1.38804 3.34966,-1.38804 2.23872,0 4.55859,1.61579 5.03894,4.71321 1.0583,0.17511 2.76768,0.63901 3.87461,1.88046 0.74904,0.84263 1.09925,1.92506 1.00969,3.12996 -0.21167,2.83275 -2.16122,4.52605 -5.21404,4.52605 -0.25626,0 -0.49242,-0.0124 -0.70006,-0.0285 -2.72272,4.63974 -8.80351,7.48894 -16.09724,7.48894 -4.2208,0 -8.37214,-0.9808 -11.88082,-2.79217 -0.1667,1.13544 -0.61452,2.1082 -1.34308,2.91025 -1.34309,1.47724 -3.59386,2.25882 -6.50814,2.25882 -3.23158,0 -7.08207,-0.94023 -10.70444,-2.55602 0.49241,0.60647 1.01773,1.19649 1.53062,1.6688 2.62511,2.41747 7.87132,4.88393 13.66733,4.94937 h 0.0815 c 0.76915,0 2.03473,-0.11406 3.5043,-0.24859 2.22226,-0.19923 4.98592,-0.45147 7.59057,-0.45147 4.32681,0 6.97642,0.67958 8.34399,2.14074 1.81503,1.93749 2.38092,9.31238 1.65637,14.35935 -0.54944,3.82599 -1.72582,6.29245 -3.49223,7.33431 -4.21239,2.48291 -11.24986,3.74045 -20.9161,3.74045 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path12"
      d="m 55.35661,11.95788 c 14.89673,0 29.65491,9.30437 29.19101,27.77851 -0.11808,4.6847 -0.99726,14.34728 1.77042,17.59934 1.05429,1.24146 4.72528,2.65765 6.91903,2.65765 1.0053,0 1.69731,-0.2972 1.69731,-1.04186 -0.008,-3.08097 1.92104,-4.61159 3.88302,-4.61159 1.96162,0 3.97222,1.54268 4.07823,4.61159 0,0 5.08353,0.20764 4.80278,3.99269 -0.22811,3.06087 -2.63352,3.5573 -4.17181,3.5573 -0.73698,0 -1.27399,-0.11405 -1.27399,-0.11405 -2.48291,4.96582 -8.80388,7.57448 -15.52367,7.57448 -4.45659,0 -9.08427,-1.1475 -12.88979,-3.52038 0.40285,4.17584 -2.62146,5.89764 -6.84189,5.89764 -4.2208,0 -9.67063,-1.73387 -14.06251,-4.46902 0,0 2.12063,3.50028 4.18022,5.39682 2.93036,2.6986 8.49826,5.16104 14.36337,5.22611 0.0285,0 0.061,0 0.0936,0 2.0106,0 6.78888,-0.69604 11.09523,-0.69604 3.26411,0 6.26393,0.39883 7.58252,1.81137 2.14111,2.28331 2.85725,17.44837 -1.60373,20.07787 -4.52568,2.66569 -12.16121,3.59385 -20.38311,3.59385 -12.3323,0 -25.98757,-2.0881 -32.46719,-3.52074 -0.27673,-0.0611 -0.55346,-0.12612 -0.82617,-0.19923 C 25.27437,101.03231 18.70518,91.99265 18.87188,81.97218 l 0.1996,-11.92141 c 0,0 -10.8711396,-3.98062 -14.5181496,-11.73423 C -3.9125096,40.33482 10.3451,18.64116 31.74192,18.64116 c 1.06197,0 2.14074,0.0526 3.23963,0.16267 5.60446,-4.57075 13.00823,-6.85004 20.37507,-6.85004 m 0,-2.09201 c -7.88777,0 -15.31603,2.40135 -21.0181,6.78486 -0.86711,-0.0651 -1.73789,-0.0976 -2.59258,-0.0976 -11.05063,0 -21.1486,5.51891 -27.0216696,14.76622 -5.46211002,8.6083 -6.23543,19.03601 -2.07169,27.90093 3.18695,6.77244 11.0706996,10.81411 14.2942396,12.23469 l -0.1751,10.4968 c -0.0896,5.32773 1.60373,10.61488 4.7622,14.88028 3.19503,4.31439 7.77408,7.42789 12.90221,8.76293 0.30122,0.0775 0.60245,0.15062 0.90367,0.21569 5.57997,1.23341 19.63846,3.56973 32.91903,3.56973 9.8578,0 17.07439,-1.30653 21.44544,-3.88704 2.05557,-1.21294 3.39865,-3.93164 3.99708,-8.08737 0.67154,-4.66423 0.37031,-12.77207 -1.92945,-15.22208 -1.57924,-1.68525 -4.47304,-2.47085 -9.10876,-2.47085 -2.65399,0 -5.4458,0.25261 -7.68451,0.45586 -1.44069,0.13051 -2.69019,0.2442 -3.41072,0.2442 h -0.0691 c -3.94004,-0.0446 -7.59897,-1.24548 -10.27307,-2.75526 2.01462,0.50887 3.98062,0.78158 5.7675,0.78158 3.21915,0 5.73862,-0.89966 7.2813,-2.60099 0.45184,-0.49644 0.93219,-1.19247 1.26595,-2.12064 3.39024,1.52221 7.26083,2.34034 11.18442,2.34034 7.3833,0 13.61068,-2.82471 16.66314,-7.46445 0.045,0 0.0896,0 0.13452,0 3.60593,0 6.00329,-2.10418 6.25553,-5.49479 0.11004,-1.49369 -0.32973,-2.84481 -1.26997,-3.90312 -1.07037,-1.2049 -2.58417,-1.78688 -3.76457,-2.06763 -0.79364,-3.20746 -3.40267,-4.87589 -5.93018,-4.87589 -1.55072,0 -3.00384,0.60208 -4.09066,1.69292 -0.73661,0.73662 -1.5913,1.9905 -1.81941,3.94407 -1.84354,-0.13855 -4.50558,-1.33906 -4.98995,-1.90897 -1.84756,-2.17328 -1.53025,-9.81722 -1.35514,-13.91994 0.0325,-0.82216 0.0651,-1.59935 0.0855,-2.27491 C 86.85099,31.6004 84.21382,24.45728 79.01623,19.12553 73.27322,13.23589 64.65286,9.85768 55.36461,9.85768 Z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path13"
      d="m 9.9864804,45.41067 c -0.0691,-7.6805 4.6481396,-15.23853 11.6081096,-18.60866 2.3769,-1.15994 5.05502,-1.80735 7.74155,-1.78688 l 2.16925,0.0164 c -2.50703,6.74392 -3.32114,12.17767 -1.98611,19.3248 0.16268,0.96473 0.61854,3.16652 0.82618,4.14331 C 29.86109,47.6815 29.41327,46.84327 29.01042,45.98017 25.92506,39.68772 25.60373,32.69119 27.86255,26.07339 l 1.47761,2.04716 c -1.10729,0.008 -2.20618,0.14659 -3.29264,0.38274 -8.07128,1.88448 -13.85889,9.10474 -16.0566596,16.90294 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path14"
      d="M 85.87278,40.93727 C 84.31,40.54648 82.67374,40.37978 81.01737,40.49384 c -1.65674,0.11369 -3.32956,0.5169 -4.93731,1.17199 1.39207,-1.02979 2.96326,-1.88046 4.67264,-2.45 1.70937,-0.57394 3.54926,-0.85908 5.40522,-0.87516 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path15"
      d="m 84.89344,49.34999 c -1.68488,-0.35021 -3.52038,-0.008 -5.16469,0.639 1.32261,-1.47761 2.97935,-2.68214 4.9735,-3.24401 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path16"
      d="m 86.27308,56.9815 c -1.46957,-0.11369 -2.95486,0.10199 -4.26979,0.89563 0.75708,-1.48967 2.1656,-2.65801 3.66332,-3.4352 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path17"
      d="m 88.55273,58.56476 -3.14202,2.77609 0.88723,-4.0987 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path18"
      d="M 91.3928,58.69526 C 91.12009,60.197 90.465,61.42639 89.71998,62.67187 89.5818,61.41798 89.37013,60.03432 88.79218,58.95993 L 91.3928,58.69124 Z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path19"
      d="m 18.43685,71.42676 c 9.34089,2.93438 18.38457,1.1029 22.61342,-7.4809 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path20"
      d="m 18.43685,71.42676 c 9.34089,2.93438 18.38457,1.1029 22.61342,-7.4809"
      stroke="#e3e4e9"
      stroke-width="6.42"
      stroke-miterlimit="10"
    />
    <path
      id="path21"
      d="M 66.36154,107.48378 C 53.70316,106.77971 38.30196,96.89742 33.31201,87.11712 c 1.43264,8.12393 3.82599,13.82197 7.3588,17.88412 7.58253,1.88448 18.58417,2.8938 25.69475,2.48254 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path22"
      d="m 73.8227,71.36973 c -4.78669,-3.1709 -10.65582,-9.12119 -12.71102,-15.02285 -2.78011,8.14403 0,17.14714 8.64888,17.28167 2.72272,0.0446 4.06214,-2.25882 4.06214,-2.25882 z"
      fill="#e3e4e9"
      stroke="#e3e4e9"
      stroke-width="3.85"
      stroke-miterlimit="10"
    />
    <path
      id="path23"
      d="M 91.35661,84.52016 C 83.8026,83.06704 80.83934,88.73255 85.89435,91.50023 Z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path24"
      d="M 91.35661,84.52016 C 83.8026,83.06704 80.83934,88.73255 85.89435,91.50023"
      stroke="#e3e4e9"
      stroke-width="3.85"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      id="path25"
      d="m 106.0128,92.07051 -0.23981,-0.13452 c -1.05831,-0.59404 -4.56699,-2.60063 -5.31567,-3.55731 -2.32425,-2.95887 -1.42862,-8.31913 0.3864,-12.05556 1.77482,-3.65089 4.35533,-5.83257 6.90733,-5.83257 2.34436,0 4.40358,1.68927 6.12539,5.01444 1.70133,3.29665 1.24548,8.46975 -1.09084,12.30415 -1.67282,2.74721 -3.98063,4.25735 -6.50009,4.25735 h -0.27271 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path26"
      d="m 107.75069,71.53642 c 1.73387,0 3.54926,1.26193 5.19758,4.44855 2.67008,5.16908 -0.82617,15.03528 -6.66276,15.03528 0,0 -4.32645,-2.42588 -5.0064,-3.293 -3.40267,-4.33047 1.15189,-16.19485 6.47158,-16.19485 m 0,-2.09212 c -3.00384,0 -5.86109,2.34034 -7.8472,6.41857 -2.01864,4.15171 -2.88174,9.82928 -0.26869,13.15884 0.77354,0.98483 3.48821,2.62109 5.62493,3.8216 l 0.47633,0.26869 h 0.54543 c 2.89782,0 5.52293,-1.6889 7.39133,-4.76183 2.51106,-4.1232 2.98337,-9.72766 1.1274,-13.32554 -2.38128,-4.61158 -5.15299,-5.58033 -7.05355,-5.58033 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path27"
      d="m 63.76933,69.17159 c 2.0552,-1.37964 6.63023,-1.2049 8.97459,1.97807 0,0 -0.57393,1.5467 -2.6741,1.74995 -4.34692,0.4193 -6.30451,-3.72802 -6.30451,-3.72802 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path28"
      d="m 92.47194,91.02829 -6.57722,0.47194"
      stroke="#e3e4e9"
      stroke-width="3.85"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="path29"
      d="m 105.13435,71.82961 c 0,0 3.42679,2.56443 2.17327,4.83129 -1.14787,2.07567 -4.47706,0.84262 -4.47706,0.84262"
      stroke="#e3e4e9"
      stroke-width="3.85"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      id="path30"
      d="m 50.15463,69.98132 c -7.86364,-4.66825 -10.4968,-7.14714 -15.50319,-14.84373 0,0 0.27673,5.29922 4.55053,9.9799 3.9236,4.29391 10.94864,4.86785 10.94864,4.86785 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path31"
      d="m 102.8938,76.96395 c 0.14879,-0.0175 0.32353,0.0263 0.49936,0.19192 l 0.001,0.001 c 0.46499,0.4299 0.89709,1.0181 1.12484,1.64723 0.21276,0.58819 0.24419,1.19978 -0.0238,1.75873 l -0.0581,0.11113 -0.002,0.004 c -0.31585,0.60208 -0.90185,0.99762 -1.52843,1.12593 0.54835,-0.24931 0.99141,-0.71029 1.14276,-1.29629 0.14732,-0.56552 -0.0154,-1.05721 -0.31146,-1.46079 -0.29026,-0.39554 -0.71285,-0.71395 -1.11388,-0.95887 -0.19484,-0.13782 -0.27161,-0.29903 -0.28404,-0.44745 -0.0128,-0.15427 0.0431,-0.31475 0.14805,-0.44343 0.10529,-0.12868 0.25151,-0.21532 0.40541,-0.2336 z"
      fill="#e3e4e9"
      stroke="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path32"
      d="m 85.89472,91.5006 c -3.6019,1.46116 -2.51106,5.71047 0.52093,5.84464 z"
      fill="#eff0f4"
      style="stroke-width: 0.365564"
    />
    <path
      id="path33"
      d="m 86.19156,92.22515 c -1.91263,0.47231 -2.86529,2.58051 -1.53025,4.18424 0.4193,0.5085 1.06232,0.83824 1.75836,0.93585 -1.51015,0.11405 -2.93877,-1.08244 -3.15445,-2.61708 -0.31731,-1.65637 0.89563,-3.2601 2.34034,-3.95211 1.03381,-0.49241 1.67684,1.08682 0.59038,1.45312 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path34"
      d="m 67.05392,42.9804 c -1.01773,2.20984 -2.49095,-0.20764 -5.21404,-0.13453 -3.71193,0.10163 -4.76585,-1.77846 -3.74849,-3.99268 1.01737,-2.21422 3.85049,-3.08098 6.32499,-1.94151 2.4745,1.13982 3.65491,3.8545 2.63754,6.06434 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
    <path
      id="path35"
      d="m 55.85268,55.8987 c 0,0 2.78011,1.29446 5.36026,-0.18315 2.58052,-1.47761 2.25078,-4.79876 2.25078,-4.79876 -1.81905,2.93475 -4.14732,4.44855 -7.61104,4.98191 z"
      fill="#e3e4e9"
      style="stroke-width: 0.365564"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconWellFedElephant',
  }
</script>

<style scoped lang="less"></style>
